import { render, staticRenderFns } from "./work-order-history.vue?vue&type=template&id=eff13fda&"
import script from "./work-order-history.vue?vue&type=script&lang=js&"
export * from "./work-order-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports